import React from "react"
import {FetchLeaderBoard} from "../leaderboard/FetchLeaderBoard"
import "./leaderboard.css"


export default class Leaderboard extends React.Component{
   
  render() {
    return(
      <div className="leaderboard">
        <Title>Leaderboard</Title>
        <ListOfPlayers />
      </div>
    )
  }
}

function Title(props) {
  return <h2 className="leaderboard__title">{props.children}</h2>
}

class ListOfPlayers extends React.Component {
  render() {

    return (
      <div className="leaderboard__list" >
        <HeaderOfList/>
        <List />
      </div>
    )
  }
}

class List extends React.Component {

  componentDidMount() {
    this.interval = setInterval(() => {
      FetchLeaderBoard.getList().then(users => this.setState({users}))
    }, 5000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }
  
  render() {
    
    console.log(this.state)
    let list = (this.state && (this.state.users.length > 0))
    ? this.state.users.sort((a, b) => a.clicks - b.clicks).map((elem, index) => <ListItem key={elem.id} index={index + 1} user={elem}/>)
    : <p>No users found</p>

    return(
      <>
        {list}
      </>
    )
  }
}

function HeaderOfList(props) {
  return (
    <div className="leaderboard__info">
        <span className="leaderboard__column-name">Name</span>
        <span className="leaderboard__column-name">Clicks</span>
        <span className="leaderboard__column-name">Difficult</span>
    </div>
  )
}

function ListItem(props) {
  return (
    <div className="leaderbroad__item">
      <span className="leaderbroad__item-id">{props.index}</span>
      <span className="leaderbroad__item-elem">{props.user.name}</span>
      <span className="leaderbroad__item-elem">{props.user.clicks}</span>
      <span className="leaderbroad__item-elem">{props.user.difficult}</span>
    </div>
  )
}